import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheck, Eye, Brain } from 'lucide-react';
import { trackEvent } from './utils/metaPixel';
export function HeroSection() {
  return <section className="relative min-h-[90vh] w-full overflow-hidden flex items-center pt-20 pb-16 lg:pt-32 lg:pb-24" data-id="element-138">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-neural-pattern opacity-50" data-id="element-139"></div>
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent/5 rounded-full blur-[120px] pointer-events-none" data-id="element-140"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-141">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-142">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-143">
            <FadeIn delay={0.1} data-id="element-144">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-surfaceHighlight border border-white/10 text-accent text-sm font-medium mb-6" data-id="element-145">
                <Brain className="w-4 h-4" data-id="element-146" />
                <span data-id="element-147">Hackea el sistema nervioso autónomo</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-148">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black tracking-tight text-white mb-4 leading-[1.1]" data-id="element-149">
                LA MENTE <br className="hidden sm:block" data-id="element-150" />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-accent-light" data-id="element-151">
                  AL DESNUDO
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-152">
              <h2 className="text-xl sm:text-2xl font-semibold text-slate-300 mb-6" data-id="element-153">
                El Manual del Detector de Mentiras Humano
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-154">
              <p className="text-lg text-slate-400 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-155">
                Cómo leer pensamientos ocultos a través de las señales no
                verbales que nadie puede fingir.
              </p>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-156">
              <div className="flex flex-col sm:flex-row items-center gap-6 justify-center lg:justify-start" data-id="element-157">
                <CTAButton onClick={() => trackEvent('AddToCart', {
                content_name: 'La Mente Al Desnudo',
                value: 19.0,
                currency: 'USD'
              })} data-id="element-158" />
              </div>
              <div className="mt-6 flex items-center justify-center lg:justify-start gap-6 text-sm text-slate-500" data-id="element-159">
                <div className="flex items-center gap-2" data-id="element-160">
                  <ShieldCheck className="w-4 h-4 text-accent" data-id="element-161" />
                  <span data-id="element-162">Acceso Inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-163">
                  <Eye className="w-4 h-4 text-accent" data-id="element-164" />
                  <span data-id="element-165">Lectura Silenciosa</span>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none relative" data-id="element-166">
            <FadeIn delay={0.4} direction="left" data-id="element-167">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-white/10 bg-surface p-2" data-id="element-168">
                <div className="absolute inset-0 bg-gradient-to-tr from-accent/20 to-transparent opacity-20 mix-blend-overlay" data-id="element-169"></div>
                <img src="https://cdn.magicpatterns.com/uploads/iyHkb6vUc95LzL3Mf8Kpmr/la_mente_al_desnudo(3).png" alt="La Mente Al Desnudo Book Cover" className="w-full h-auto object-cover rounded-xl" data-id="element-170" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}